import styled from "@emotion/styled";
import { TEXT_16, TEXT_20 } from "../../../styles/globalTypography";

/* A native <details> accordion. Same hairlines, same 32px rhythm and the same
   rotating chevron as the landing page's FAQ, with no component library behind
   it: keyboard support and the open/closed semantics come from the element. */
export const AccordionItem = styled("details")`
  border-top: 1px solid var(--Solitude);
  &:last-of-type {
    border-bottom: 1px solid var(--Solitude);
  }
  interpolate-size: allow-keywords;

  & > summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin: 32px 0;
    cursor: pointer;
    list-style: none;
  }
  & > summary::-webkit-details-marker {
    display: none;
  }
  & > summary:focus-visible {
    outline: 2px solid var(--Blue);
    outline-offset: 4px;
    border-radius: 4px;
  }

  & .black-acc-title {
    max-width: 548px;
    width: 87%;
    ${TEXT_20}
    font-weight: 500;
    color: var(--Black);
    cursor: pointer;
  }

  /* the chevron, as a CSS caret rather than an icon package */
  & .chevron {
    flex: 0 0 auto;
    width: 0.6em;
    height: 0.6em;
    font-size: 1.2rem;
    border-right: 2px solid var(--Black);
    border-bottom: 2px solid var(--Black);
    transform: rotate(45deg) translate(-0.15em, -0.15em);
    transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  &[open] .chevron {
    transform: rotate(225deg) translate(-0.1em, -0.1em);
  }

  & .acc-body {
    margin-bottom: 32px;
  }
  & .grey-body {
    max-width: 636px;
    ${TEXT_16}
    font-weight: 500;
    color: var(--Grey);
  }

  @supports (interpolate-size: allow-keywords) {
    &::details-content {
      block-size: 0;
      overflow: hidden;
      transition: block-size 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
        content-visibility 0.3s allow-discrete;
    }
    &[open]::details-content {
      block-size: auto;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    & .chevron,
    &::details-content {
      transition: none;
    }
  }
`;
